<template>
	<div class="consult-pannel">
		 <h1>商品咨询</h1>
		 <div class="container">
			<div class="goods-info">
				<!-- <div v-for="good in consult.goods_list" style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
					<img style="width: 50px;height: 50px; object-fit: cover;" :src="`${baseURL}/${good.cover}?q=30`" alt="">
					<div style="max-width: 100px;">{{ good.name_lang }}</div>
				</div> -->
				<cart-show-list :good_list="consult.goods_list"></cart-show-list>
			</div>
			<div class="messages-info">
				<consult-label-list :message_list="message_list"></consult-label-list>
			</div>
		 </div>
		
		 <el-pagination
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-sizes="[limit]"
					:page-size="limit"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					class="pagination"
				></el-pagination>
		<el-input class="input" v-model="reply" placeholder="输入我的回复" @change="send_my_reply" style="background-color: #F0F3F8;"></el-input>
	</div>
</template>

<script>
	import { add_consult_message, consult_list, consult_messages, pre_consult, reply_user_consult_message } from '../../api/api';
	import { baseURL } from '../../api/api';
	import ConsultLabelList from './consultLabelList.vue';
	import CartShowList from '../cartshow/cartshowlist.vue';
	export default {
		name:'consult-pannel',
		components:{
	
			ConsultLabelList,
			CartShowList
		},
		props: {
			consult: {
				type: Object,
				default:{}
			},
			
		},
		data() {
			return {
				page:1,
				limit:10,
				message_list:[],
				reply:'',
				baseURL,
				total:0
			}
		},
		mounted() {
			this.update_messages()
			
		},
		watch: {
			consult(newValue, oldValue) {
				this.update_messages()
			}
		},
		methods: {
			async send_my_reply(e){
				try {
					const result = await reply_user_consult_message(this.consult.id,this.reply)
					this.reply = ''
					this.update_messages()
				} catch (error) {
					//TODO handle the exception
					this.$message({
						message:error,
						type:'error'
					})
				}
				
				
				
			},
			async update_messages(){
				const result = await consult_messages(this.consult.id,this.page,this.limit)
				this.total = result.total
				this.message_list = result.list
			},
			handleCurrentChange(e){
				this.page = e
				this.update_messages()
			}
			
		},
	}
</script>

<style lang="less">
	.consult-pannel{
		
		width: 100%;
		.container{
			display: flex;
			.goods-info{
				width: 40%;
			}
			.messages-info{
				width: 60%;
				min-height: 50px;
			}
		}
		.input{
			background-color: #F0F3F8;
			height: 50px;
			width: 100%;
		}
	}
</style>